<span [ngSwitch]="taskState">
  <span *ngSwitchCase="1">Inactive</span>
  <span *ngSwitchCase="2">In Progress</span>
  <span *ngSwitchCase="3">Complete</span>
  <span *ngSwitchCase="4">Abandoned</span>
  <span *ngSwitchCase="5">Deleted</span>
  <span *ngSwitchDefault>UNKNOWN</span>
</span>